import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import FormGroup from "@material-ui/core/FormGroup";
import TextField from "@material-ui/core/TextField";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";
import DatePicker from "react-datepicker";
import PopupMessage from "../components/PopupMessage";
import { BACKEND_DATE_FORMAT } from "../components/Constants";
import GenericReportDetails from "../details/GenericReportDetails";

import RunIcon from "@material-ui/icons/PlayArrowOutlined";
import PrintIcon from "@material-ui/icons/PrintOutlined";
import DownloadIcon from "@material-ui/icons/SystemUpdateOutlined";

import { CSVLink } from "react-csv";

import { Portal } from "react-overlays";

import { AmountFormatCustom } from "../components/AmountFormatCustom";

const CalendarContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  customFont: {
    fontSize: 12,
  },
});

const CREDIT_DEBIT_COMBO = [
  { label: "Both", data: "B" },
  { label: "Credit", data: "CREDIT" },
  { label: "Debit", data: "DEBIT" },
];

const ISSUE_VOID_COMBO = [
  { label: "Both", data: "B" },
  { label: "Issue", data: "I" },
  { label: "Void", data: "V" },
];

const FREQ_COMBO = [
  { label: "Daily", data: "D" },
  { label: "Weekly", data: "W" },
  { label: "Monthly", data: "M" },
];

class GenericReportPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      report: {},
      accounts: [],
      numUsers: 0,
      users: [],
      checkAll: true,
      searchOk: false,
      firstRowCriteria: false,
      secondRowCriteria: false,

      redrawStartDate: false,
      redrawEndDate: false,
      backendStartDate: "",
      backendEndDate: "",
      selectedReason: "-1",
      startDate: null,
      endDate: null,
      checkFrom: "",
      checkTo: "",
      amountFrom: "",
      amountTo: "",
      payee: "",
      creditDebit: "B",
      account: "",
      issue: "B",
      selectedAccount: {},
      selectedCompName: "",
      selectedUser: "",
      selectedFreq: "D",
      viewPopup: false,

      dataToDownload: [],
      dataDownloadActive: false,
      disableDownload: false,
      disableRun: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    this.props.onReportChange(e);
  }

  componentDidUpdate() {
    if (this.state.redrawStartDate) {
      this.setState({ redrawStartDate: false });
    }
    if (this.state.redrawEndDate) {
      this.setState({ redrawEndDate: false });
    }
  }

  componentDidMount() {
    fetch("on_company_report_entry", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accounts: this.props.prefs.accounts,
        reportType: this.props.option.accType,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          if (reply.accounts.length === 0) {
            this.setState({
              notifyString:
                "No accounts configured for " +
                this.props.option.descr +
                " report",
            });
            this.setState({ viewPopup: true });
          } else {
            let accounts = [];
            let i;
            for (i = 0; i < reply.accounts.length; i++) {
              accounts.push({
                index: i,
                info: reply.accounts[i],
                checked: true,
              });
            }
            this.setState({ accounts: accounts });
            if (
              this.props.option.account ||
              this.props.option.freq ||
              this.props.option.excReason ||
              this.props.option.issueVoid ||
              this.props.option.creditDebit ||
              this.props.option.users ||
              this.props.option.startDate ||
              this.props.option.endDate ||
              this.props.option.startChkno ||
              this.props.option.endChkno ||
              this.props.option.startAmount ||
              this.props.option.endAmount ||
              this.props.option.payeeName
            ) {
              this.setState({ firstRowCriteria: true });
            }
            this.setState({ secondRowCriteria: false });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
    fetch("on_users", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        secureToken: this.props.secureToken,
        r: new Date().getTime(),
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) this.setState({ errorString: reply.errorString });
          this.setState({ numUsers: reply.numItems });
          this.setState({ users: reply.items });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  handleCheckAll(e) {
    let checkAll = !this.state.checkAll;
    let items = this.state.accounts;
    let i;
    for (i = 0; i < items.length; i++) {
      items[i].checked = checkAll;
    }
    this.setState({ checkAll: checkAll });
    this.setState({ accounts: items });
    this.setState({ searchOk: false });
  }

  handleCheckItem(event, index) {
    let items = this.state.accounts;
    items[index].checked = !items[index].checked;
    this.setState({ accounts: items });
    this.setState({ searchOk: false });
  }

  handleRun(e) {
    let checkedAccounts = this.getCheckedAccounts();
    if (checkedAccounts.length === 0) {
      this.setState({
        errorString:
          "All accounts are unchecked. At least one account is required.",
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (this.props.option.startDate && this.state.backendStartDate === "") {
      this.setState({ errorString: "Please select a date." });
      this.setState({ viewPopup: true });
      return;
    }
    this.run(checkedAccounts);
  }

  handlePrint(e) {
    var prtContent = document.getElementById("myReport");
    var winPrint = window.open(
      "",
      "",
      "left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0"
    );
    winPrint.document.write(prtContent.innerHTML);
    winPrint.document.close();
    winPrint.focus();
    winPrint.print();
    winPrint.close();
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
  }

  run(accounts) {
    this.setState({ searchOk: false });
    this.setState({ disableRun: true });
    this.setState({ report: {} });
    fetch("on_generic_report_request", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accounts: accounts,
        command: this.props.option.command,
        type: this.props.option.type,
        startChkno: this.state.checkFrom,
        endChkno: this.state.checkTo,
        startDate: this.state.backendStartDate,
        endDate: this.state.backendEndDate,
        startAmount: this.state.amountFrom,
        endAmount: this.state.amountTo,
        payeeName: this.state.payee,
        issueVoid: this.state.issue !== "B" ? this.state.issue : "",
        excReason:
          this.state.selectedReason !== "-1" ? this.state.selectedReason : "",
        creditDebit:
          this.state.creditDebit !== "B" ? this.state.creditDebit : "",
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ report: reply });
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else if (reply.accountData.length === 0) {
            this.setState({ notifyString: "No data found" });
            this.setState({ viewPopup: true });
          } else {
            this.setState({ report: reply });
            this.setState({ searchOk: true });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
    this.setState({ disableRun: false });
  }

  getCheckedAccounts() {
    let checkedAccounts = [];
    let accounts = this.state.accounts;
    let i;
    for (i = 0; i < accounts.length; i++) {
      if (accounts[i].checked) {
        checkedAccounts.push(accounts[i].info);
      }
    }
    return checkedAccounts;
  }

  handleStartDate(date) {
    this.setState({ searchOk: false });
    this.setState({ startDate: date });
    if (date === null) {
      this.setState({ backendStartDate: "" });
    } else {
      this.setState({ backendStartDate: date.format(BACKEND_DATE_FORMAT) });
    }
    if (!this.props.option.endDate) {
      if (date === null) {
        this.setState({ backendEndDate: "" });
      } else {
        this.setState({ backendEndDate: date.format(BACKEND_DATE_FORMAT) });
      }
    }
  }

  handleStartDateOutsideClick(e) {
    this.setState({ redrawStartDate: true });
  }

  handleEndDate(date) {
    this.setState({ searchOk: false });
    this.setState({ endDate: date });
    if (date === null) {
      this.setState({ backendEndDate: "" });
    } else {
      this.setState({ backendEndDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleEndDateOutsideClick(e) {
    this.setState({ redrawEndDate: true });
  }

  handleCheckFrom(e) {
    this.setState({ searchOk: false });
    this.setState({ checkFrom: e.target.value });
  }

  handleCheckTo(e) {
    this.setState({ searchOk: false });
    this.setState({ checkTo: e.target.value });
  }

  handleAmountFrom(e) {
    this.setState({ searchOk: false });
    this.setState({ amountFrom: e.target.value });
  }

  handleAmountTo(e) {
    this.setState({ searchOk: false });
    this.setState({ amountTo: e.target.value });
  }

  handlePayee(e) {
    this.setState({ searchOk: false });
    this.setState({ payee: e.target.value });
  }

  handleReason(e) {
    this.setState({ searchOk: false });
    this.setState({ selectedReason: e.target.value });
  }

  handleFreq(e) {
    this.setState({ searchOk: false });
    this.setState({ selectedFreq: e.target.value });
  }

  handleIssue(e) {
    this.setState({ searchOk: false });
    this.setState({ issue: e.target.value });
  }

  handleCreditDebit(e) {
    this.setState({ searchOk: false });
    this.setState({ creditDebit: e.target.value });
  }

  handleUser(e) {
    this.setState({ searchOk: false });
    this.setState({ selectedUser: e.target.value });
  }

  handleDownload() {
    // format data and headers - csvlink wants quotes
    //data={this.state.report.records}
    //header={this.state.report.columns}
    this.setState({ disableDownload: true });
    const currentRecords = this.state.report.records;
    const currentRecordsHeader = this.state.report.columns;

    var data_to_download = [];
    //var data_to_download_headers = [];
    for (var index = 0; index < currentRecords.length; index++) {
      let record_to_download = {};
      for (
        var colIndex = 0;
        colIndex < currentRecordsHeader.length;
        colIndex++
      ) {
        record_to_download[currentRecordsHeader[colIndex]] =
          currentRecords[index].values[colIndex];
      }
      data_to_download.push(record_to_download);
    }

    this.setState(
      {
        dataToDownload: data_to_download,
      },
      () => {
        this.setState({ dataDownloadActive: true });
        // click the CSVLink component to trigger the CSV download
        setTimeout(() => {
          if (!(this.csvLink === undefined)) {
            this.csvLink.link.click();
          }
        }, 3000);
        //this.csvLink.link.click();
      }
    );
    // click the CSVLink component to trigger the CSV download
    //this.csvLink.link.click();
    this.setState({ disableDownload: false });
  }

  render() {
    const { classes } = this.props;
    const datePickerTopMargin = 10;
    const reasons = this.props.reasons;
    let options = this.props.reports;
    let users = this.state.users;
    let { t } = this.props;
    return (
      <div>
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        <div>
          <Paper elevation={5}>
            <div
              style={{ display: "flex", flexDirection: "row", marginTop: 10 }}
            >
              <div style={{ marginLeft: 10 }}>
                <Typography variant="caption">
                  {t("aggregatedReport.label")}&nbsp;&nbsp;
                </Typography>
                <FormControl>
                  <NativeSelect
                    style={{ height: 48, verticalAlign: "textTop", margin: 0 }}
                    defaultValue={this.props.option.type}
                    input={<Input id="report_options" />}
                    onChange={(event) => this.handleChange(event)}
                  >
                    {options.map((n) => {
                      return (
                        <option key={n.type} value={n.type}>
                          {n.descr}
                        </option>
                      );
                    })}
                  </NativeSelect>
                </FormControl>
              </div>
              {this.props.option.account && this.state.accounts.length > 0 && (
                <div
                  style={{
                    marginLeft: 40,
                    marginTop: 20,
                    height: this.state.accounts.length > 2 ? 120 : 100,
                    width: "20%",
                    overflow: "auto",
                  }}
                >
                  <Table style={{ border: "0px solid" }} stickyHeader>
                    <TableHead>
                      <TableRow style={{ height: 30 }}>
                        <TableCell padding="none">
                          <Checkbox
                            style={{ height: 15 }}
                            checked={this.state.checkAll === true}
                            onChange={(event) => this.handleCheckAll(event)}
                            value="0"
                            color="default"
                          />
                        </TableCell>
                        <TableCell>{t("transit.header")}</TableCell>
                        <TableCell>{t("account.header")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.accounts.map((item) => {
                        return (
                          <TableRow key={item.index} style={{ height: 30 }}>
                            <TableCell padding="none">
                              <Checkbox
                                style={{ height: 15 }}
                                checked={item.checked === true}
                                onChange={(event) =>
                                  this.handleCheckItem(event, item.index)
                                }
                                value={"" + item.index}
                                color="default"
                              />
                            </TableCell>
                            <TableCell className={classes.customFont}>
                              {item.info.transit}
                            </TableCell>
                            <TableCell className={classes.customFont}>
                              {item.info.account}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              )}

              <div style={{ marginLeft: 50, marginTop: 20 }}>
                <Tooltip
                  title={t("showReportFor.tip") + this.props.option.descr}
                >
                  <Button
                    color="primary"
                    onClick={(event) => this.handleRun(event)}
                    disabled={this.state.disableRun}
                  >
                    <RunIcon />
                    &nbsp;{t("run.button")}
                  </Button>
                </Tooltip>
              </div>

              {this.state.searchOk && (
                <div style={{ marginLeft: 10, marginTop: 20 }}>
                  <Tooltip title={t("printReport.tip")}>
                    <Button
                      color="primary"
                      onClick={(event) => this.handlePrint(event)}
                    >
                      <PrintIcon />
                      &nbsp;{t("printReport.tip")}
                    </Button>
                  </Tooltip>
                </div>
              )}
              {this.state.searchOk && (
                <div style={{ marginLeft: 10, marginTop: 20 }}>
                  <Tooltip title={t("downLoadItemsFile.tip")}>
                    <Button
                      color="primary"
                      onClick={(event) => this.handleDownload(event)}
                      disabled={this.state.disableDownload}
                    >
                      <DownloadIcon />
                      &nbsp;{t("download.button")}
                    </Button>
                  </Tooltip>
                </div>
              )}
              {this.state.searchOk && this.state.dataDownloadActive && (
                <div style={{ marginLeft: 10, marginTop: 20 }}>
                  <CSVLink
                    data={this.state.dataToDownload}
                    filename={this.props.option.descr + ".csv"}
                    className="hidden"
                    ref={(r) => (this.csvLink = r)}
                    asyncOnClick={true}
                    target="_blank"
                  />
                </div>
              )}
            </div>
            {this.state.firstRowCriteria && (
              <div>
                <FormGroup row>
                  {this.props.option.excReason && (
                    <div style={{ marginLeft: 10, marginBottom: 10 }}>
                      <Typography variant="caption">
                        {t("exceptionReason.label")}
                      </Typography>
                      <FormControl>
                        <NativeSelect
                          style={{
                            height: 48,
                            verticalAlign: "textTop",
                            margin: 0,
                          }}
                          defaultValue={this.state.selectedReason}
                          input={<Input id="reason_options" />}
                          onChange={(event) => this.handleReason(event)}
                        >
                          {reasons.map((n) => {
                            return (
                              <option value={n.id}>{n.description}</option>
                            );
                          })}
                        </NativeSelect>
                      </FormControl>
                      &nbsp;&nbsp;
                    </div>
                  )}

                  {this.props.option.freq && (
                    <div style={{ marginLeft: 10, marginBottom: 10 }}>
                      <Typography variant="caption">
                        {t("freq.label")}
                      </Typography>
                      <FormControl>
                        <NativeSelect
                          style={{
                            height: 48,
                            verticalAlign: "textTop",
                            margin: 0,
                          }}
                          defaultValue={this.state.selectedFreq}
                          input={<Input id="freq_options" />}
                          onChange={(event) => this.handleFreq(event)}
                        >
                          {FREQ_COMBO.map((n) => {
                            return <option value={n.data}>{n.label}</option>;
                          })}
                        </NativeSelect>
                      </FormControl>
                      &nbsp;&nbsp;
                    </div>
                  )}

                  {this.props.option.issueVoid && (
                    <div style={{ marginLeft: 10, marginBottom: 10 }}>
                      <Typography variant="caption">
                        {t("issueVoid.label")}
                      </Typography>
                      <FormControl>
                        <NativeSelect
                          style={{
                            height: 48,
                            verticalAlign: "textTop",
                            margin: 0,
                          }}
                          defaultValue={this.state.issue}
                          input={<Input id="issue_options" />}
                          onChange={(event) => this.handleIssue(event)}
                        >
                          {ISSUE_VOID_COMBO.map((n) => {
                            return <option value={n.data}>{n.label}</option>;
                          })}
                        </NativeSelect>
                      </FormControl>
                      &nbsp;&nbsp;
                    </div>
                  )}

                  {this.props.option.creditDebit && (
                    <div style={{ marginLeft: 10, marginBottom: 10 }}>
                      <Typography variant="caption">
                        {t("creditDebit.label")}
                      </Typography>
                      <FormControl>
                        <NativeSelect
                          style={{
                            height: 48,
                            verticalAlign: "textTop",
                            margin: 0,
                          }}
                          defaultValue={this.state.creditDebit}
                          input={<Input id="credit_debit_options" />}
                          onChange={(event) => this.handleCreditDebit(event)}
                        >
                          {CREDIT_DEBIT_COMBO.map((n) => {
                            return <option value={n.data}>{n.label}</option>;
                          })}
                        </NativeSelect>
                      </FormControl>
                      &nbsp;&nbsp;
                    </div>
                  )}
                  {this.props.option.users && (
                    <div style={{ marginLeft: 10, marginBottom: 10 }}>
                      <Typography variant="caption">
                        {t("userScope.label")}
                      </Typography>
                      <FormControl>
                        <NativeSelect
                          style={{
                            height: 30,
                            verticalAlign: "textTop",
                            margin: 0,
                          }}
                          defaultValue={this.state.selectedUser}
                          input={<Input id="user_options" />}
                          onChange={(event) => this.handleUser(event)}
                        >
                          <option value="0">All Users</option>
                          {users.map((n) => {
                            return <option value={n.id}>{n.name}</option>;
                          })}
                        </NativeSelect>
                      </FormControl>
                      &nbsp;&nbsp;
                    </div>
                  )}
                  {this.props.option.startDate && this.props.option.endDate && (
                    <div style={{ marginLeft: 10, marginBottom: 10 }}>
                      <Typography variant="caption">
                        {t("startDate.label")}:
                        {!this.state.redrawStartDate && (
                          <div style={{ marginTop: datePickerTopMargin }}>
                            <DatePicker
                              isClearable
                              disabledKeyboardNavigation
                              dateFormat="LL"
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={this.state.startDate}
                              onChange={(event) => this.handleStartDate(event)}
                              onClickOutside={(event) =>
                                this.handleStartDateOutsideClick(event)
                              }
                              popperContainer={CalendarContainer}
                            />
                          </div>
                        )}
                      </Typography>
                    </div>
                  )}
                  {this.props.option.startDate && !this.props.option.endDate && (
                    <div style={{ marginLeft: 10, marginBottom: 10 }}>
                      <Typography variant="caption">
                        {t("date.header")}:
                        {!this.state.redrawStartDate && (
                          <div style={{ marginTop: datePickerTopMargin }}>
                            <DatePicker
                              isClearable
                              disabledKeyboardNavigation
                              dateFormat="LL"
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={this.state.startDate}
                              onChange={(event) => this.handleStartDate(event)}
                              onClickOutside={(event) =>
                                this.handleStartDateOutsideClick(event)
                              }
                              popperContainer={CalendarContainer}
                            />
                          </div>
                        )}
                      </Typography>
                    </div>
                  )}
                  {this.props.option.endDate && (
                    <div style={{ marginLeft: 10, marginBottom: 10 }}>
                      <Typography variant="caption">
                        {t("endDate.label")}:
                        {!this.state.redrawEndDate && (
                          <div style={{ marginTop: datePickerTopMargin }}>
                            <DatePicker
                              isClearable
                              disabledKeyboardNavigation
                              dateFormat="LL"
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={this.state.endDate}
                              onChange={(event) => this.handleEndDate(event)}
                              onClickOutside={(event) =>
                                this.handleEndDateOutsideClick(event)
                              }
                              popperContainer={CalendarContainer}
                            />
                          </div>
                        )}
                      </Typography>
                    </div>
                  )}
                  {this.props.option.startChkno && (
                    <TextField
                      style={{ marginLeft: 10, marginBottom: 10 }}
                      margin="dense"
                      id="checkFrom"
                      label={t("checkNoFrom.label")}
                      type="text"
                      defaultValue={this.state.checkFrom}
                      onChange={(event) => this.handleCheckFrom(event)}
                      onKeyPress={(event) => {
                        return event.charCode >= 48 && event.charCode <= 57
                          ? true
                          : event.preventDefault();
                      }}
                    />
                  )}
                  {this.props.option.endChkno && (
                    <TextField
                      style={{ marginLeft: 10, marginBottom: 10 }}
                      margin="dense"
                      id="checkTo"
                      label={t("checkNoTo.label")}
                      type="text"
                      defaultValue={this.state.checkTo}
                      onChange={(event) => this.handleCheckTo(event)}
                      onKeyPress={(event) => {
                        return event.charCode >= 48 && event.charCode <= 57
                          ? true
                          : event.preventDefault();
                      }}
                    />
                  )}
                  {this.props.option.startAmount && (
                    <TextField
                      style={{ marginLeft: 10, marginBottom: 10 }}
                      margin="dense"
                      id="amountFrom"
                      label={t("amountFrom.label")}
                      type="text"
                      defaultValue={this.state.amountFrom}
                      onChange={(event) => this.handleAmountFrom(event)}
                      InputProps={{
                        inputComponent: AmountFormatCustom,
                      }}
                    />
                  )}
                  {this.props.option.endAmount && (
                    <TextField
                      style={{ marginLeft: 10, marginBottom: 10 }}
                      margin="dense"
                      id="amountTo"
                      label={t("amountTo.label")}
                      type="text"
                      defaultValue={this.state.amountTo}
                      onChange={(event) => this.handleAmountTo(event)}
                      InputProps={{
                        inputComponent: AmountFormatCustom,
                      }}
                    />
                  )}
                  {this.props.option.payeeName && (
                    <TextField
                      style={{ marginLeft: 10, marginBottom: 10 }}
                      margin="dense"
                      id="payee"
                      label={t("payeeName.label")}
                      defaultValue={this.state.payee}
                      onChange={(event) => this.handlePayee(event)}
                    />
                  )}
                </FormGroup>
              </div>
            )}
            {/*}
            {this.state.secondRowCriteria && (
              <div>
                <FormGroup row>
                  {this.props.option.startDate && this.props.option.endDate && (
                    <div style={{ marginLeft: 10, marginBottom: 10 }}>
                      <Typography variant="caption">
                        {t("startDate.label")}:
                        {!this.state.redrawStartDate && (
                          <div style={{ marginTop: datePickerTopMargin }}>
                            <DatePicker
                              isClearable
                              disabledKeyboardNavigation
                              dateFormat="LL"
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={this.state.startDate}
                              onChange={(event) => this.handleStartDate(event)}
                              onClickOutside={(event) =>
                                this.handleStartDateOutsideClick(event)
                              }
                            />
                          </div>
                        )}
                      </Typography>
                    </div>
                  )}
                  {this.props.option.startDate && !this.props.option.endDate && (
                    <div style={{ marginLeft: 10, marginBottom: 10 }}>
                      <Typography variant="caption">
                        {t("date.header")}:
                        {!this.state.redrawStartDate && (
                          <div style={{ marginTop: datePickerTopMargin }}>
                            <DatePicker
                              isClearable
                              disabledKeyboardNavigation
                              dateFormat="LL"
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={this.state.startDate}
                              onChange={(event) => this.handleStartDate(event)}
                              onClickOutside={(event) =>
                                this.handleStartDateOutsideClick(event)
                              }
                            />
                          </div>
                        )}
                      </Typography>
                    </div>
                  )}
                  {this.props.option.endDate && (
                    <div style={{ marginLeft: 10, marginBottom: 10 }}>
                      <Typography variant="caption">
                        {t("endDate.label")}:
                        {!this.state.redrawEndDate && (
                          <div style={{ marginTop: datePickerTopMargin }}>
                            <DatePicker
                              isClearable
                              disabledKeyboardNavigation
                              dateFormat="LL"
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={this.state.endDate}
                              onChange={(event) => this.handleEndDate(event)}
                              onClickOutside={(event) =>
                                this.handleEndDateOutsideClick(event)
                              }
                            />
                          </div>
                        )}
                      </Typography>
                    </div>
                  )}
                  {this.props.option.startChkno && (
                    <TextField
                      style={{ marginLeft: 10, marginBottom: 10 }}
                      margin="dense"
                      id="checkFrom"
                      label={t("checkNoFrom.label")}
                      type="text"
                      defaultValue={this.state.checkFrom}
                      onChange={(event) => this.handleCheckFrom(event)}
                      onKeyPress={(event) => {
                        return event.charCode >= 48 && event.charCode <= 57
                          ? true
                          : event.preventDefault();
                      }}
                    />
                  )}
                  {this.props.option.endChkno && (
                    <TextField
                      style={{ marginLeft: 10, marginBottom: 10 }}
                      margin="dense"
                      id="checkTo"
                      label={t("checkNoTo.label")}
                      type="text"
                      defaultValue={this.state.checkTo}
                      onChange={(event) => this.handleCheckTo(event)}
                      onKeyPress={(event) => {
                        return event.charCode >= 48 && event.charCode <= 57
                          ? true
                          : event.preventDefault();
                      }}
                    />
                  )}
                  {this.props.option.startAmount && (
                    <TextField
                      style={{ marginLeft: 10, marginBottom: 10 }}
                      margin="dense"
                      id="amountFrom"
                      label={t("amountFrom.label")}
                      type="text"
                      defaultValue={this.state.amountFrom}
                      onChange={(event) => this.handleAmountFrom(event)}
                      onKeyPress={(event) => {
                        return event.charCode === 46 ||
                          (event.charCode >= 48 && event.charCode <= 57)
                          ? true
                          : event.preventDefault();
                      }}
                    />
                  )}
                  {this.props.option.endAmount && (
                    <TextField
                      style={{ marginLeft: 10, marginBottom: 10 }}
                      margin="dense"
                      id="amountTo"
                      label={t("amountTo.label")}
                      type="text"
                      defaultValue={this.state.amountTo}
                      onChange={(event) => this.handleAmountTo(event)}
                      onKeyPress={(event) => {
                        return event.charCode === 46 ||
                          (event.charCode >= 48 && event.charCode <= 57)
                          ? true
                          : event.preventDefault();
                      }}
                    />
                  )}
                  {this.props.option.payeeName && (
                    <TextField
                      style={{ marginLeft: 10, marginBottom: 10 }}
                      margin="dense"
                      id="payee"
                      label={t("payeeName.label")}
                      defaultValue={this.state.payee}
                      onChange={(event) => this.handlePayee(event)}
                    />
                  )}
                </FormGroup>
              </div>
            )}
            {*/}
            <div>&nbsp;&nbsp;</div>
          </Paper>
        </div>
        {this.state.searchOk && (
          <div id="myReport">
            <GenericReportDetails report={this.state.report} />
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(GenericReportPage));
